<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">成就管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column  prop="pgname" label="游戏名称" >
        </el-table-column>
        <el-table-column  prop="pgid" label="游戏Id" >
        </el-table-column>
        <el-table-column align="center" label="操作">
            <template slot-scope="scope">
            <el-button size="mini" type="text" v-preventReClick @click="editAchieve(scope.$index, scope.row)">管理成就</el-button>
            <el-button size="mini" type="text" v-preventReClick @click="delInfomercial(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" type="text" v-if="scope.$index != 0" @click="sortClick(scope.row , scope.$index , 'top')">上移</el-button>
            <el-button size="mini" type="text" v-if="scope.$index != (listData.length - 1)" @click="sortClick(scope.row , scope.$index , 'bottom')">下移</el-button>
            </template>
        </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
        <!-- 新增 -->
        <el-dialog :visible.sync="editAchieveFlag" width="40%" @click="editAchieveFlag = false">
            <el-button size="small" @click="addAchieveClick">添加成就</el-button>
            <el-tabs v-model="tabName" @tab-click="handleClick">
                <el-tab-pane v-for="(item , index) in tabList" :key="index" :label="item.name" :name="item.id">
                    <el-button size="small" @click="addNumClick">添加次数</el-button>
                    <el-button size="small" @click="editAchieveClick(item)">修改</el-button>
                    <el-button size="small" @click="delAchieve()">删除</el-button>
                    <el-button size="small" v-if="index != 0" @click="achieveMove(1)">上移</el-button>
                    <el-button size="small" v-if="index != tabList.length - 1" @click="achieveMove(0)">下移</el-button>
                    <el-table size="small" :data="item.hdAchieveTimes" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
                        <el-table-column  prop="times" label="次数" >
                        </el-table-column>
                        <el-table-column  prop="integral" label="奖励约豆" >
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                            <el-button size="mini" type="text" v-preventReClick @click="editNumClick(scope.$index, scope.row)">修改</el-button>
                            <el-button size="mini" type="text" v-preventReClick @click="achievetimeDel(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editAchieveFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="addAchieveFlag" width="30%" @click="addAchieveFlag = false">
            <el-form label-width="120px" :model="addAchieveForm" :rules="rules" ref="addAchieveForm">
                <el-form-item label="成就名称" prop="name">
                <el-input size="small" v-model="addAchieveForm.name" auto-complete="off" placeholder="成就名称"></el-input>
                </el-form-item>
                <el-form-item label="code" prop="code">
                <el-input size="small" v-model="addAchieveForm.code" auto-complete="off" placeholder="code"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addAchieveFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="addAchieveSubmit('addAchieveForm')">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="addNumFlag" width="30%" @click="addNumFlag = false">
            <el-form label-width="120px" :model="addNumForm" :rules="rules" ref="addNumForm">
                <el-form-item label="次数" prop="times">
                <el-input size="small" v-model="addNumForm.times" auto-complete="off" placeholder="次数"></el-input>
                </el-form-item>
                <el-form-item label="奖励约豆" prop="integral">
                <el-input size="small" v-model="addNumForm.integral" auto-complete="off" placeholder="奖励约豆"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addNumFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="addNumFormSubmit('addNumForm')">保存</el-button>
            </div>
        </el-dialog>
</div>
</template>
<script>
import VideoPlay from '../video.vue'
import Pagination from '../../components/Pagination'
import { pgmexpList , pgmexpDel , gmpsettingUpload , achieveMove  , 
    achievetimeAdd , achieveAdd , achieveSelect , pgmexpMove , achievetimeDel ,
    achieveDel , achieveUpdate , achievetimeUpdate} from '../../api/userMG'
export default {
    data(){
        return{
            addNumFlag:false,
            addNumForm:{},
            addNumRow:{},
            tabList:[],
            tabName:'',
            addAchieveForm:{},
            addAchieveRow:{},
            addAchieveFlag:false,
            editAchieveForm:{},
            editAchieveFlag:false,
            maxexp:'',
            typeNum:'',
            videoFlag:false,
            videoUrl:'',
            rules: {
                integral : [
                { required: true, message: '请输入游戏名称', trigger: 'blur' }
                ],
                pgid : [
                { required: true, message: '请输入游戏id', trigger: 'blur' }
                ],
                name : [
                { required: true, message: '请输入成就名称', trigger: 'blur' }
                ],
                code : [
                { required: true, message: '请输入code', trigger: 'blur' }
                ],
                integral : [
                { required: true, message: '请输入奖励约豆', trigger: 'blur' },
                {
                    pattern: /^\+?[1-9][0-9]*$/,
                    required: true,
                    message: '请输入正确约豆值',
                    trigger: 'blur'
                }
                ],
                times : [
                { required: true, message: '请输入次数', trigger: 'blur' },
                {
                    pattern: /^\+?[1-9][0-9]*$/,
                    required: true,
                    message: '请输入正确次数',
                    trigger: 'blur'
                }
                ],
                num: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    {
                        pattern: /^\+?[1-9][0-9]*$/,
                        required: true,
                        message: '请输入正确序号',
                        trigger: 'blur'
                    }
                ],
            },
            editSubForm:{},
            editFlag:false,
            fileList:[],
            videoFileList:[],
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            options2:[{
                value: 1,
                label: '图片'
                }, {
                value: 2,
                label: '视频'
                },],
            editForm:{
                type:'1',
                link:'',
                num:'',
                remark:'',
                status:'1'
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        Pagination,
        VideoPlay
    },
    created(){
        this.getdata()
    },
    methods:{
        editNumClick(index , row){
            this.addNumForm = {
                integral:row.integral,
                times:row.times,
                id:row.id
            }
            this.addNumRow = row
            this.addNumFlag = true
        },
        editAchieveClick(e){
            this.addAchieveForm = {
                name:e.name,
                code:e.code,
                id:e.id
            }
            this.addAchieveRow = e
            this.addAchieveFlag = true
        },
        delAchieve(){
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                achieveDel({id:this.tabName}).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.achieveSelect(this.editAchieveForm.pgid , 1)
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        addNumClick(){
            this.addNumFlag = true
            this.addNumForm = {
                integral:'',
                times:'',
            }
        },
        achievetimeDel(index , row){
            console.log(row)
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                achievetimeDel({id:row.id}).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.achieveSelect(this.editAchieveForm.pgid , 0)
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        achieveMove(flag){
            achieveMove({
                id:this.tabName,
                flag:flag,
            }).then(res=>{
                if(!res.message){
                    this.$message.error(res.message)
                }else {
                    this.$message.success('操作成功')
                    this.achieveSelect(this.editAchieveForm.pgid , 0)
                }
            })
        },
        addNumFormSubmit(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if(this.addNumForm.id == undefined){
                        achievetimeAdd({
                            achieveid:this.tabName,
                            integral:this.addNumForm.integral,
                            times:this.addNumForm.times,
                        }).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('创建成功')
                                this.addNumFlag = false
                                this.achieveSelect(this.editAchieveForm.pgid , 0)
                            }
                        })
                    }else {
                        let data = this.addNumRow
                        data.integral = this.addNumForm.integral
                        data.times = this.addNumForm.times
                        achievetimeUpdate(data).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('修改成功')
                                this.addNumFlag = false
                                this.achieveSelect(this.editAchieveForm.pgid , 0)
                            }
                        })
                    }
                    
                } else {
                    return false
                }
            })
        },
        addAchieveSubmit(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if(this.addAchieveForm.id == undefined){
                        achieveAdd({
                            gameid:this.editAchieveForm.pgid,
                            code:this.addAchieveForm.code,
                            name:this.addAchieveForm.name,
                        }).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('创建成功')
                                this.addAchieveFlag = false
                                this.achieveSelect(this.editAchieveForm.pgid , this.tabName == ''?1:0)
                            }
                        })
                    }else {
                        let data = this.addAchieveRow
                        data.name = this.addAchieveForm.name
                        data.code = this.addAchieveForm.code
                        achieveUpdate(data).then(res=>{
                            if(!res.success){
                                this.$message.error(res.message)
                            }else {
                                this.$message.success('修改成功')
                                this.addAchieveFlag = false
                                this.achieveSelect(this.editAchieveForm.pgid , 0)
                            }
                        })
                    }
                    
                } else {
                    return false
                }
            })
        },
        addAchieveClick(){
            this.addAchieveFlag = true
            this.addAchieveForm = {
                name:'',
                code:''
            }
        },
        editAchieve(index , row){
            
            this.editAchieveFlag = true
            this.editAchieveForm = row
            this.achieveSelect(row.pgid , 1)
        },
        achieveSelect(id , type){
            achieveSelect({id:id}).then(res=>{
                this.tabList = res.data
                if(type == 1 && res.data.length != 0){
                    this.tabName = res.data[0].id
                }
            })
        },
        sortClick(row , index , type){
            let data = {
                id:row.id,
                order:1
            }
            if(type == 'top'){
                data.flag = 1
            }else if(type == 'bottom') {
                data.flag = 0
            }
            pgmexpMove(data).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else {
                    this.getdata()
                    this.$message.success('操作成功')
                }
                
            })
        },
        maxexpSubmit(){
            let ms = /^\+?[1-9][0-9]*$/
            if(!ms.test(this.maxexp)){
                this.$message.error('请输入正确经验值')
            }else {
                gmpsettingUpload({
                    id:this.maxexpId,
                    maxexp:this.maxexp
                }).then(res=>{
                    if(!res.success){
                        this.$message.error(res.message)
                    }else {
                        this.$message.success('修改成功')
                    }
                })
            }
        },  
        videoClick(row){
                this.videoUrl = row
                this.videoFlag = true
        },  
        // 新建提交
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    let formData = new FormData()
                    if(this.videoFileList[0] == undefined){
                        this.$message.error('上传封面')
                        return
                    }
                    formData.append('file' , this.videoFileList[0])
                    this.$axios({
                        method: "POST",
                        url: "/yunyue-houtai/file/upload",
                        headers: {
                            "Content-Type": "multipart/form-data",
                            token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                        },
                        data: formData,
                    }).then(res=>{
                        console.log(res.data.data)
                        if(res.data.success == true){
                            pgmexpAdd({
                                pgname:this.editForm.pgname,
                                expvalue:this.editForm.expvalue,
                                pgid:this.editForm.pgid,
                                pic:res.data.data
                            }).then(AddRes=>{
                                if(!AddRes.success){
                                    this.$message.error(AddRes.message)
                                }else {
                                    this.$message.success('添加成功')
                                    this.getdata()
                                    this.editFormVisible = false
                                    this.videoFileList = []
                                    this.editForm = {
                                        pgname:'',
                                        expvalue:'',
                                        pgid:'',
                                    }
                                }
                            })
                        }else {
                            this.$message.error(res.data.messages)
                        }
                        
                    })
                } else {
                    return false
                }
            })
        },
          
        // 删除
        delInfomercial(index , row){
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                pgmexpDel(row.id).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        handleChange(file){
            console.log(file)
            this.fileList = [file.file] 
            console.log(this.fileList)
        },
        videoHandleChange(file){
            console.log(file)
            this.videoFileList = [file.file] 
            console.log(this.videoFileList)
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
            this.fileList = []
            this.videoFileList = []
            this.editForm = {
                pgname:'',
                expvalue:'',
                pgid:'',
            }
        },
        getdata(){
            pgmexpList({flag:1}).then(res=>{
                this.listData = res.data
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .img_inner{
    transform: all .3s;
    cursor: pointer;
  }
  .img_inner:hover{
    transform: scale(1.2);
  }
</style>


// WEBPACK FOOTER //
// src/views/system/achieve.vue